function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 24.45,
    style: {
      fill: "#FF6F52"
    },
    width: 145.925,
    height: 463.102
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.032,
    y: 252.535,
    style: {
      fill: "#4EBFED"
    },
    width: 145.925,
    height: 235.004
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.076,
    y: 174.995,
    style: {
      fill: "#FCD577"
    },
    width: 145.925,
    height: 312.556
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.396a906d41fd6eeba0053509fab9f9d1.svg";
export { ForwardRef as ReactComponent };